import React from 'react';
import { FileDown, Edit } from 'lucide-react';

interface PreviewHeaderProps {
  onEdit: () => void;
  onDownload: () => void;
}

export function PreviewHeader({ onEdit, onDownload }: PreviewHeaderProps) {
  return (
    <div className="flex justify-between items-center mb-8">
      <h1 className="text-3xl font-bold">Resume Preview</h1>
      <div className="flex gap-4">
        <button
          onClick={onEdit}
          className="text-indigo-600 hover:text-indigo-700 flex items-center gap-2"
        >
          <Edit className="w-5 h-5" />
          Edit
        </button>
        <button
          onClick={onDownload}
          className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 
            transition-colors flex items-center gap-2"
        >
          <FileDown className="w-5 h-5" />
          Download PDF
        </button>
      </div>
    </div>
  );
}